module.exports = __webpack_public_path__ + "static/media/5DPO17.b6488797.jpg";